var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerBox',{attrs:{"current":6}}),_c('bannerBox',{ref:"bannerChild"}),_c('div',{staticClass:"content_box"},[_c('div',{staticClass:"box3"},[_c('sp'),_c('ppt'),_c('wd')],1)]),_c('footerBox'),_c('Back-top',{attrs:{"height":100,"bottom":200}},[_c('div',{staticClass:"iconfont icon-shangjiantou"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }